import { combineReducers } from 'redux';
import { authentication } from './Authentication/reducers';
import { emergencyAlert } from './Components/EmergencyAlert/reducers';

export default combineReducers({
    authentication,
    emergencyAlert,
})